<template>
  <div class="travel">
    <Header></Header>
    <Nav></Nav>
    <Toptitle title="驴友社区"></Toptitle>
    <div class="activitiesCommunity_nav">
      <router-link tag="a" to="/travel" class="selection">驴友行记</router-link>
      <router-link tag="a" to="/travelMito">美图</router-link>
    </div>
    <div class="banner">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(slide,index) in swiperSlides" :key="index">
          <div class="swiper_img" @click="goArticleDetail(slide.paperid)">
            <img :src="slide.picture" alt="">
            <div class="caption">
              <h1>{{slide.title}}</h1>
              <p>{{slide.introdesc}}</p>
            </div>
          </div>
        </swiper-slide>
        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
    <!--    <div class="banner travel_banner">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(slide,index) in swiperSlides" :key="index">
          <div class="swiper_img" :style="{ 'background': 'url(' + slide+ ') no-repeat center center', 'background-size': 'cover'}">
            <i></i>
            <div class="swiper_text">
              <h3>定向大赛跑进东源，以道兴村传承红色精神</h3>
              <p>8月24至25日，2019南粤古驿道“天翼4K高清杯”定向大赛第三站在广东省河源市东源县义合镇的苏家围、下屯村火热开赛，广东省体育局局长王禹平</p>
            </div>
          </div>
        </swiper-slide>
        如果需要导航按钮
        <div class="swiper-button-prev" slot="button-prev"> </div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div> -->
    <div class="travel_list" v-if="ArticaleList.length>0">
      <router-link tag="a" v-for="(item,index) of ArticaleList" :to="{path:'/travelDetails',query:{id:item.id,type:0}}"
        class="travel_item" :key="index">
        <div v-if="index%2 == 0" class="travel_item_img">
          <img :src="item.picture" />
        </div>
        <div class="travel_item_right activitiesCommunity_item_right">
          <h3>{{item.title}}</h3>
          <p>{{item.subtitle}}</p>
          <div>
            <span><img src="../assets/static/images/activitiesCommunityIcon1.png" alt=""><b class="travel_b">{{item.authorname}}</b></span>
            <span><img src="../assets/static/images/activitiesCommunityIcon2.png" alt="">{{item.zuan ? item.zuan : 0}}</span>
            <span><img src="../assets/static/images/activitiesCommunityIcon3.png" alt="">{{item.commentNumber}}</span>
          </div>
        </div>
        <div v-if="index%2 != 0" class="travel_item_img">
          <img :src="item.picture" />
        </div>
      </router-link>
      <el-pagination background small layout="prev, pager, next" @current-change="handleCurrentChange" :page-size='listJson.pageSize'
        :total="totalRecord" class="newspage showInPc" :current-page="listJson.pageNo" prev-text='< 上一页' next-text='下一页 >'></el-pagination>

      <el-pagination background small layout="prev, pager, next" @current-change="handleCurrentChange" :page-size='listJson.pageSize'
        :total="totalRecord" class="newspage showInPhone" :current-page="listJson.pageNo" prev-text='<' next-text='>'></el-pagination>
    </div>
    <div class="null" v-else>
      暂无数据
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './common/Header.vue'
  import Nav from './common/Nav.vue'
  import Footer from './common/Footer.vue'
  import 'swiper/dist/css/swiper.css'
  import {
    swiper,
    swiperSlide
  } from 'vue-awesome-swiper'
  import {
    request
  } from 'http';
  import Toptitle from './common/Toptitle.vue'
  export default {
    data() {
      return {
        swiperOption: {
          notNextTick: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        },
        swiperSlides: [],
        listJson: {
          type: 100001,
          pageNo: 1,
          pageSize: 10,
        },
        ArticaleList: []
      }
    },
    components: {
      Header,
      Footer,
      Nav,
      swiper,
      swiperSlide,
      Toptitle
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    mounted() {
      this.getMemberArticaleList(100001)
      this.getbanner()
    },
    methods: {
      getMemberArticaleList(type) {
        this.listJson.type = type
        this.listJson.userid = this.userinfoId,
          this.axios.post('api/c_article/getList.do', this.qs(this.listJson))
          .then(res => {
            this.totalRecord = res.data.page.totalRecord
            this.ArticaleList = res.data.page.results
            this.listJson.pageNo = res.data.page.pageNo
            window.scrollTo({
              top: 100,
              behavior: 'smooth'
            })
          })
      },
      handleCurrentChange(val) {
        console.log(val);
        this.listJson.pageNo = val
        this.getMemberArticaleList(this.listJson.type)
      },
      getbanner() {
        this.axios.post('api/b_bannermag/getListByNavId.do', this.qs({
            navigateid: sessionStorage.getItem("index_childrenId")
          }))
          .then(res => {
            this.swiperSlides = res.data.data
          })
      },
      goArticleDetail(id) {
        this.$router.push({
          name: 'articleDetail',
          query: {
            id: id
          }
        })
      },
    }
  }
</script>

<style>
</style>
